interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <h1 className="flex items-center gap-3 cursor-pointer group">
            <a href="/" className={`flex items-center gap-3 transition-all duration-300 ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              <div className={`relative w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110 ${scrolled ? 'bg-gradient-to-br from-teal-500 to-teal-600 shadow-lg' : 'bg-white shadow-xl'}`}>
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className={`relative text-xl font-bold tracking-tight ${scrolled ? 'text-white' : 'text-teal-600'} group-hover:text-white transition-colors duration-300`}>EP</span>
              </div>
              <span className="text-2xl font-bold tracking-tight">Excl Projects</span>
            </a>
          </h1>
          <div className="flex items-center gap-8">
            <a 
              href="#services"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('services');
              }}
              className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-teal-600 hover:scale-110 cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Services
            </a>
            <a 
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('about');
              }}
              className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-teal-600 hover:scale-110 cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              About
            </a>
            <a 
              href="#process"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('process');
              }}
              className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-teal-600 hover:scale-110 cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Process
            </a>
            <a 
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}
              className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-teal-600 hover:scale-110 cursor-pointer ${scrolled ? 'text-gray-700' : 'text-white'}`}
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
